var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.fixedNum=='notop'?'loadingWrap_noFixed':'loadingWrap']},[_c('mt-spinner',{attrs:{"size":40,"type":"triple-bounce"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }